/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const labelStyles = css({
	display: 'block',
	color: token('color.text.subtle'),
	marginBottom: token('space.075'),
});

type FieldLabelProps = {
	children: React.ReactNode;
	htmlFor: string;
};

export const FieldLabel = ({ children, htmlFor }: FieldLabelProps): JSX.Element => (
	<label css={labelStyles} htmlFor={htmlFor}>
		{children}
	</label>
);
